<template>
  <div :class="['halloween-item-frame', props.variant]">
    <div v-if="$slots.title" class="halloween-item-frame-title">
      <slot name="title" />
    </div>

    <div class="halloween-item-frame-content" :style="{ gap: props.contentGap }">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
interface Props {
  variant?: 'translucent' | 'default' | 'item' | 'rareItem';
  borderWidth?: number;
  borderColor?: string;
  contentGap?: number;
}

const props = defineProps<Props>();
</script>
<style>
.halloween-item-frame {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 8px;
  width: fit-content;
  justify-content: center;
  align-items: center;

  background: #052430;
  border: 1px solid #10364a;
  border-radius: 10px;

  font-family:
    PT Serif,
    serif;
}

.halloween-item-frame.translucent {
  background: radial-gradient(98.59% 98.53% at 51.79% 1.47%, rgba(0, 131, 173, 0.75) 0%, rgba(0, 0, 0, 0) 100%)
    rgba(13, 36, 47, 0.75);
  border: 1px solid #1e353e;
  backdrop-filter: blur(1px);
  border-radius: 12px;
}

.halloween-item-frame.item {
  background: radial-gradient(92.3% 92.29% at 50% -7.05%, #0083ad 0%, rgba(0, 0, 0, 0) 100%),
    radial-gradient(59.02% 71.08% at 84.01% 85.82%, #040f14 0%, #081b25 100%);
  border: 1px solid #1e353e;
  box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.25);
  border-radius: 9px;
}

.halloween-item-frame.rareItem {
  background: radial-gradient(92.3% 92.29% at 50% -7.05%, rgba(180, 166, 62, 0.5) 0%, rgba(0, 0, 0, 0) 100%),
    radial-gradient(59.02% 71.08% at 84.01% 85.82%, #040f14 0%, #081b25 100%);
  border: 1px solid #1e353e;
  box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.25);
  border-radius: 9px;
}

.halloween-item-frame-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
}

.halloween-item-frame-content {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 0;
}
</style>
